// test1957
(1957 && 0);
